import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CheckoutPending.css";

const WHATSAPP_PHONE = "50236825505";

function CheckoutPending() {
  const navigate = useNavigate();

  const [pedidoId] = useState(() => {
    try {
      return sessionStorage.getItem("pedido_id") || "";
    } catch {
      return "";
    }
  });

  const [noPo] = useState(() => {
    try {
      const raw = sessionStorage.getItem("pedido_no_po");
      return raw ? String(raw) : "";
    } catch {
      return "";
    }
  });

  const whatsappPedidoHref = useMemo(() => {
    const orderRef = pedidoId ? `#${pedidoId}` : "mi pedido";
    const text = `Hola, he realizado mi pedido (${orderRef}) se entrega pendiente de pago`;
    return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(text)}`;
  }, [pedidoId]);

  useEffect(() => {
    try {
      localStorage.removeItem("cart");
      localStorage.removeItem("cart_expiration");
      localStorage.removeItem("art_expiration");
    } catch {
      //
    }

    try {
      sessionStorage.removeItem("grupo_reserva");
      sessionStorage.removeItem("checkout_subtotal");
      sessionStorage.removeItem("checkout_core_charge_total");
      sessionStorage.removeItem("checkout_grand_total");
      sessionStorage.removeItem("checkout_total");
      sessionStorage.removeItem("checkout_envio");
      sessionStorage.removeItem("checkout_pago");
      sessionStorage.removeItem("checkout_reserva_resumen");
      sessionStorage.removeItem("pedido_id");
      sessionStorage.removeItem("pedido_no_po");
    } catch {
      //
    }
  }, []);

  return (
    <div className="checkout-pending-container">
      <div className="checkout-pending-bg-glow checkout-pending-bg-glow-top" />
      <div className="checkout-pending-bg-glow checkout-pending-bg-glow-left" />
      <div className="checkout-pending-bg-glow checkout-pending-bg-glow-right" />

      <div className="checkout-pending-shell">
        <div className="checkout-pending-card">
          <div className="checkout-pending-top-line" />

          <div className="checkout-pending-icon-wrap">
            <div className="checkout-pending-cart-track">
              <div className="checkout-pending-animated-cart">
                <span className="checkout-pending-cart-handle" />
                <span className="checkout-pending-cart-basket" />
                <span className="checkout-pending-cart-wheel checkout-pending-cart-wheel--left" />
                <span className="checkout-pending-cart-wheel checkout-pending-cart-wheel--right" />
              </div>
            </div>
          </div>

          <span className="checkout-pending-badge">Pedido pendiente</span>

          <h1 className="checkout-pending-title">
            Tu pedido fue registrado correctamente
          </h1>

          <p className="checkout-pending-description">
            Hemos recibido tu solicitud y quedó en estado pendiente. En breve
            validaremos la información para continuar con el proceso de tu orden.
          </p>

          <div className="checkout-pending-order-hero">
            <span className="checkout-pending-order-hero-label">
              Número de orden
            </span>
            <strong className="checkout-pending-order-hero-id">
              {pedidoId ? `#${pedidoId}` : "Generándose..."}
            </strong>
          </div>

          <div
            className={`checkout-pending-summary ${
              !noPo ? "checkout-pending-summary-single" : ""
            }`}
          >
            {noPo ? (
              <div className="checkout-pending-summary-box">
                <span className="label">No. PO</span>
                <strong>{noPo}</strong>
              </div>
            ) : null}

            <div className="checkout-pending-summary-box checkout-pending-summary-box-status">
              <span className="label">Estado</span>
              <strong className="pending">Pendiente</strong>
            </div>
          </div>

          <div className="checkout-pending-note">
            Puedes revisar el estado del pedido desde tu cuenta o volver a la
            tienda para seguir comprando.
          </div>

          <div className="checkout-pending-actions">
            <a
              className="checkout-pending-btn checkout-pending-btn-whatsapp"
              href={whatsappPedidoHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              Finalizar el pedido por whatsapp
            </a>

            <button
              className="checkout-pending-btn checkout-pending-btn-secondary"
              onClick={() => navigate("/cliente/account")}
            >
              Ver mis pedidos
            </button>

            <button
              className="checkout-pending-btn checkout-pending-btn-primary"
              onClick={() => navigate("/store/inicio")}
            >
              Volver a la tienda
            </button>
          </div>
        </div>

        <div className="checkout-pending-footer">cyravi by Nexus Bridge</div>
      </div>
    </div>
  );
}

export default CheckoutPending;